import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout'
import Home from '@/views/layout/home.vue'
import Engineering from '@/views/layout/engineering.vue'
import Contact from '@/views/layout/contact.vue'
import Product from '@/views/layout/product.vue'
import Company from '@/views/layout/company.vue'
import Honour from '@/views/layout/honour.vue'
import Development from '@/views/layout/development.vue'
import Introduce from '@/views/layout/introduce.vue'
import ProductDetail from '@/views/layout/productDetail.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        { path: '/home', component: Home },
        { path: '/engineering', component: Engineering },
        { path: '/contact', component: Contact },
        { path: '/product', component: Product },
        { path: '/company', component: Company },
        { path: '/honour', component: Honour },
        { path: '/development', component: Development },
        { path: '/introduce', component: Introduce },
        { path: '/productdetail/:id', component: ProductDetail }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // 返回 { x: 0, y: 0 } 表示滚动到页面顶部
    return { x: 0, y: 0 }
  }
})

export default router
